import { useEffect, useState } from "react";
import { Checkbox, Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";
import { mdlFactSheetInfo } from "../../models/domain/FactSheetInfo";
import { mdlLanguage } from "../../models/ui-models/Language";
import { InputHelper } from "../../utils/InputHelper";
import _ from "lodash";
import { mdlFactSheetRoomItem } from "../../models/service-models/fact-sheet/FactSheetRoomItem";
import { mdlIdNameIndexPair } from "../../models/domain/IdNameIndexPair";
import { data } from "jquery";
import { render } from "react-dom";
import { mdlFactSheetRoomItemValuePair } from "../../models/service-models/fact-sheet/FactSheetRoomItemValuePair";
import { mdlFactSheetRoomItemSaveRequest } from "../../models/service-models/fact-sheet/FactSheetRoomItemSaveRequest";
import { useMutation } from "react-query";
import { FactSheetService } from "../../services/FactSheetService";
import { toast } from "react-toastify";

export type FactSheetRoomInfosProps = {
    selectedLanguage?: mdlLanguage;
    activeCell?: string;
    selectedHotel?: string;
    tableItems?: mdlFactSheetRoomItem[];
    fnExtraChange?: Function;
    fnActiveCellChange?: Function;
}

export const FactSheetRoomInfos = (function FactSheetRoomInfos(props: FactSheetRoomInfosProps) {
    const [items, setItems] = useState<mdlFactSheetRoomItem[]>();
    const { t } = useTranslation();


    useEffect(() => {
        if(props.tableItems){
            setItems(props.tableItems);
        }
    }, [props]);
    const save = (values: any) => { }

    const handleKeyPress = (e: any) => {
        if (e.key === 'Enter' || e.key === 'Escape') {
            props.fnActiveCellChange && props.fnActiveCellChange("")
        }
    }

    const defaultColumns: TableProps<mdlIdNameIndexPair>['columns'] = [
        {
            title: t("factSheet.roomInfos.roomType"),
            dataIndex: 'name',
            key: 'name',
            width:300
        },
    ];

    const saveItem = useMutation({
        mutationFn: (data: mdlFactSheetRoomItemSaveRequest) => {
            return FactSheetService.SaveRoomItem(data)
        }
    })
    
    const setMutateSaveItem = async (data: mdlFactSheetRoomItemSaveRequest, fnSuccess: Function) => {
        const result = await saveItem.mutateAsync(data)
        if (result) {
            fnSuccess(result);
        }
    }

    const saveItemObject =  (group:mdlFactSheetRoomItem, roomType:mdlFactSheetRoomItem,room:any, value:mdlFactSheetRoomItemValuePair | undefined) => {
        
        if(!roomType || !value){
            return;
        }
        const request = {
            hotelId:props.selectedHotel,
            hotelRoomTypeId:value.item?.hotelRoomtypeId,
            basicFactSheetRoomId: value.item?.basicFactSheetRoomId,
            value:(value.value ? "" : "true") 
        } as mdlFactSheetRoomItemSaveRequest;
        setMutateSaveItem(request, (result: any) => {
            if(result && result.header && result.header.success != undefined && result.header.success){
            const targetValueIndex = group.values?.findIndex(v => v.id === value.id && v.index === value.index) as number;

            if (targetValueIndex !== -1 && group.values) {
                const updatedValues = [...group.values];
                updatedValues[targetValueIndex] = {
                    ...updatedValues[targetValueIndex],
                    value: !updatedValues[targetValueIndex].value,
                };

                const updatedGroup = { ...group, values: updatedValues };
                    
                setItems(prevItems => {
                    if(prevItems){
                        const updatedItems = prevItems.map(item => {
                            if (item.roomNames?.some(r => r.index === room.index)) {
                                return updatedGroup;
                            }
                            return item;
                        });
                        return updatedItems;
                    }
                        return prevItems;
                });
            }
            
                toast.success(t("common.success"));
            }else{
              toast.error((_.first(result.header.messages) as any)?.message);
      
              setItems(prevItems => {
                if(prevItems){
                   const revertedItems = prevItems.map(item => {
                     if (item.roomNames?.some(r => r.index === room.index)) {
                        return group; 
                     }
                    return item;
                   });
                  return revertedItems;
                }
                return prevItems;
               });
            }
        });
    }

    const colorList = ["primary","secondary","warning","info","success","danger"];
    return (
        <>

            <div className="row">
                {
                    items
                    &&
                    <>

                        {items.map((item: mdlFactSheetRoomItem, index: number) => (
                            
                            <>
                                <div className="col-sm-12">
                                    <h4>
                                        <span className={`badge badge-md badge-dot bg-outline-${colorList[index%colorList.length]}`}>{t("factSheet.roomInfos.title")}</span>
                                    </h4>
                                    <hr />
                                </div>
                                <div className="col-sm-12 mb-4">
                                    <Table<mdlIdNameIndexPair>
                                        size="middle"
                                        columns={[...defaultColumns,...item.roomNames?.map( x=> (
                                                    { 
                                                        title:x.name, 
                                                        dataIndex:x.name, 
                                                        key:x.name , 
                                                        render: (_: any, record: any) => (
                                                            <>
                                                                <Checkbox checked={item.values?.find( a=> a.id == record.id && a.index == (`${x.index}-${record.index}`))?.value ?? false} onChange={() => { saveItemObject(item,record,x, item.values?.find( a=> a.id == record.id && a.index == (`${x.index}-${record.index}`))) } } ></Checkbox>
                                                            </>
                                                        )
                                                    } )) ?? []]}
                                        pagination={false}
                                        scroll={{ x: 'max-content' }}
                                        dataSource={
                                            item.roomTypes?.map((data: mdlIdNameIndexPair, index: number)=> ({ ...data, key: index }))
                                        }
                                    />
                                </div>
                            </>
                        ))}
                    </>
                }</div>
        </>
    )
})